<template>
    <div class="user-dropdown">
        <div class="user-button">
            
            <div class="user-dropdown-img">
                <img src="@/assets/images/user.png" alt="Usuário">
                <!-- <Gravatar :email="user.email" alt="User" /> -->
            </div>
            <span class="d-none d-sm-block mr-1">{{ userName }}</span>
            <i class="fas fa-angle-down"></i>
        </div>
        <div class="user-dropdown-content">
            <a href @click.prevent="changePassword"><i class="fas fa-lock"></i> Alterar Senha</a>
            <a href @click.prevent="logout"><i class="fas fa-sign-out-alt"></i> Sair</a>
        </div>
        <ChangePassword :user="userEmail" modalID="modal-pwd1" />
    </div>
</template>

<script>
import ChangePassword from './ChangePassword'

import { userKey } from '@/global'
import { mapState } from 'vuex'

export default {
    name: 'UserDropdown',
    components: { ChangePassword },
    computed: {
        ...mapState(['user']),
        userName(){
            if(!this.user.user)
                return ""
            else
                return this.user.user.name
        },
        userEmail(){
            if(!this.user.user)
                return ""
            else
                return this.user.user.email

        }
    },
    methods: {
        logout() {
            localStorage.removeItem(userKey)
            this.$store.commit('setUser', null)
            this.$router.push({ name: 'login' })
        },
        changePassword(){
            this.$bvModal.show('modal-pwd1');
        }
        
    },
    mounted(){
        "mounted userdropdown"
    }
}
</script>

<style>
    .user-dropdown {
        position: relative;
        height: 100%;
    }

    .user-button {
        display: flex;
        align-items: center;
        /*color: #333;*/
        font-weight: 100;
        height: 100%;
        padding: 0px 20px;
    }

    .user-dropdown:hover {
        background-color: rgba(0, 0, 0, 0.3);
    }

    .user-dropdown-img {
        margin: 0px 10px;
    }

    .user-dropdown-img > img {
        max-height: 50px;
        max-width: 50px;
        border-radius: 100px;
    }


    .user-dropdown-content {
        position: absolute;
        right: 0px;
        background-color: #f9f9f9;
        min-width: 170px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        padding: 10px;
        z-index: 1;

        display: flex;
        flex-direction: column;
        flex-wrap: wrap;

        visibility: hidden;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s linear;
    }

    .user-dropdown:hover .user-dropdown-content {
        visibility: visible;
        opacity: 1;
    }

    .user-dropdown-content a {
        text-decoration: none;
        color: #000;
        padding: 10px;
    }

    .user-dropdown-content a:hover {
        text-decoration: none;
        color: #ededed;
        background-color: #494E53;
        
    }

</style>
